<template>
    <VoidClaim :Type="AppServiceID"></VoidClaim>
</template>
<script>
import VoidClaim from '@/components/MedicalSupply/VoidClaim.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
         AppServiceID :'', 
        }
    },
 components: {
    VoidClaim  : VoidClaim
        },
   created: function() {      
        this.$emit('update:layout', LayoutDefault);
         this.AppServiceID= this.$store.getters.GetMedicalID; 
    },
    beforeCreate: function() { 
        
        this.$store.dispatch('AddServiceID',this.$store.getters.GetMedicalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetMedicalID); 
    },
}
</script>
